// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"_6cc260e6","pageLinks":"_4236c5ae"};